import ApiService from './api';
import { Dispute } from '@/types';
import { safeArray } from '../utils/money';

export interface DisputeFilters {
  status?: string;
  payment_id?: string;
  date_from?: string;
  date_to?: string;
}

export interface DisputeEvidenceRequest {
  customer_communication?: string;
  customer_signature?: string;
  receipt?: string;
  shipping_documentation?: string;
  shipping_tracking_number?: string;
  shipping_date?: string;
  additional_information?: string;
  refund_policy?: string;
  refund_policy_disclosure?: string;
  service_documentation?: string;
  product_description?: string;
}

export class DisputeService {
  /**
   * 获取争议列表
   */
  static async listDisputes(
    page: number = 1,
    limit: number = 20,
    filters?: DisputeFilters
  ): Promise<{
    data: Dispute[];
    meta: {
      total: number;
      per_page: number;
      current_page: number;
      last_page: number;
    };
  }> {
    const params = { page, limit, ...filters };
    const response = await ApiService.get('/merchant/payments/disputes', params);
    return {
      data: safeArray<Dispute>(response.data),
      meta: response.meta || { total: 0, per_page: limit, current_page: page, last_page: 1 },
    };
  }

  /**
   * 获取争议详情
   */
  static async getDispute(id: string): Promise<Dispute> {
    const response = await ApiService.get<Dispute>(`/merchant/payments/disputes/${id}`);
    return response.data;
  }

  /**
   * 提交争议证据
   */
  static async submitEvidence(id: string, evidence: DisputeEvidenceRequest): Promise<void> {
    await ApiService.post(`/merchant/payments/disputes/${id}/evidence`, evidence);
  }

  /**
   * 获取争议证据
   */
  static async getEvidence(id: string): Promise<any> {
    const response = await ApiService.get(`/merchant/payments/disputes/${id}/evidence`);
    return response.data;
  }

  /**
   * 接受争议
   */
  static async acceptDispute(id: string): Promise<void> {
    await ApiService.post(`/merchant/payments/disputes/${id}/accept`);
  }

  /**
   * 挑战争议
   */
  static async challengeDispute(id: string): Promise<void> {
    await ApiService.post(`/merchant/payments/disputes/${id}/challenge`);
  }
}

export default DisputeService;
